import { render } from "./dialogCustomer.vue?vue&type=template&id=db0a655c&scoped=true"
import script from "./dialogCustomer.vue?vue&type=script&lang=js"
export * from "./dialogCustomer.vue?vue&type=script&lang=js"

import "./dialogCustomer.vue?vue&type=style&index=0&id=db0a655c&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db0a655c"]])

export default __exports__